import Head from 'next/head';
import React from 'react';
import { renderJsonLdScript, getFaqStructuredData } from 'libs/universal/structuredData';
import { faqItems } from 'components/AdvisorLp/TrendingQuestionsTextBlock/TrendingQuestionsTextBlock';

const title = 'Team-Z, Your Wedding Planning Advisors';
const description =
  'Real answers, real experts. Team-Z is here to support you along the path to your perfect day. Reach out to a wedding expert now.';

export default function AdvisorLpHeader(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href="https://www.zola.com/advisor" />
      {renderJsonLdScript(getFaqStructuredData(faqItems))}
    </Head>
  );
}
